// mergePDF app entry — client-side router for 3 pages
// Architecture: see /ARCHITECTURE.md
//
// Pages: landing -> editor -> result
// PDF merge is fully client-side via pdf-lib.

import "./styles/main.css";
import { renderLanding } from "./pages/landing";
import { renderEditor } from "./pages/editor";
import { renderResult } from "./pages/result";

type Route = "landing" | "editor" | "result";

function getRoute(): Route {
  const hash = window.location.hash.replace("#/", "");
  if (hash === "editor" || hash === "result") return hash;
  return "landing";
}

function navigate(route: Route) {
  window.location.hash = `/${route}`;
}

async function render() {
  const app = document.getElementById("app");
  if (!app) throw new Error("#app root missing");

  const route = getRoute();
  app.innerHTML = "";

  switch (route) {
    case "landing":
      await renderLanding(app, () => navigate("editor"));
      break;
    case "editor":
      await renderEditor(app, () => navigate("result"), () => navigate("landing"));
      break;
    case "result":
      await renderResult(app, () => navigate("landing"));
      break;
  }
}

window.addEventListener("hashchange", render);
window.addEventListener("DOMContentLoaded", render);
